import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Router, RouterModule } from '@angular/router'
import { EluxIcon, EluxLoading } from '@elxjs/ui'
import { ClickOutsideDirective } from '@common'
import { TenantsAvailable } from '@models'
import { AuthService } from '@services'

@Component({
  standalone: true,
  selector: 'app-header',
  imports: [CommonModule, EluxIcon, EluxLoading, RouterModule, ClickOutsideDirective],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  showTenants: boolean = false
  showProfile: boolean = false

  loadingTenant: boolean = true

  tenantsAvaibles: TenantsAvailable[] | null = []
  tenantActive: TenantsAvailable | null = null

  allowManageUsers: boolean = false

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    this.loadingTenant = true

    this.tenantsAvaibles = await this.authService.getTenantsAvaibles()
    this.tenantActive = await this.authService.getTenantActive()

    const userInfo = await this.authService.getUserInfo()
    if (userInfo) {
      const tenant = userInfo.Tenants.filter((x) => x.Id == this.tenantActive?.id)[0]
      if (tenant && tenant.Roles) {
        this.allowManageUsers = tenant.Roles.includes('user-and-profile')
      }
    }

    this.loadingTenant = false
  }

  openTenants() {
    this.showTenants = !this.showTenants
    this.showProfile = false
  }

  openProfile() {
    this.showProfile = !this.showProfile
    this.showTenants = false
  }

  changeTenant(tenant: TenantsAvailable) {
    this.authService.setTenantActive(tenant)
  }

  logout() {
    this.authService.logout()
    this.router.navigateByUrl('/', { replaceUrl: true })
  }

  getUserInfo() {
    return this.authService.getUserInfo()
  }
}
